module.exports = __webpack_public_path__ + "static/media/ccb_poster.b6de3991.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/ccb_poster.jpeg
// module id = 184
// module chunks = 0